import React from 'react';
import PropTypes from 'prop-types';

const HeaderTopLeft = ({ children }) => <div className="o-grid__item">{children}</div>

export default HeaderTopLeft;

HeaderTopLeft.propTypes = {
  children: PropTypes.node.isRequired,
};
